<div
    class="flex gap-small align-items-center p-2 folder"
    (click)="selectedChange.emit(!selected)"
    [class.selected]="selected"
>
    <div class="flex gap-small align-items-center">
        <i [class]="selected ? 'pi pi-folder-open' : 'pi pi-folder'"></i>
        <div>{{ name }}</div>
    </div>
    <p-badge [value]="count" severity="success"/>
</div>
